class FetchDocumentTemplates {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchDocumentTemplates;
